module.exports = {
  transpileDependencies: true,
  outputDir: process.env.VUE_OUTPUT_DIR,
  filenameHashing: true,
  devServer: {
    proxy: process.env.VUE_APP_PROXY,
    webSocketServer: false,
  },
  css: {
    loaderOptions: {
      scss: {
        prependData: `
          @import "@/scss/variables.scss";
          @import "@/scss/mixins.scss";
          @import "@/scss/functions.scss";
        `,
      },
    },
  },
  configureWebpack: {
    output: {
      filename: 'js/[name].[contenthash:8].js',
      chunkFilename: 'js/[name].[contenthash:8].js',
    },
  },
};
